export default __webpack_public_path__ + "static/media/2.b2a29e01.jpg";